<div class="apps-banner-row">
    <div class="container h-100">
        <div class="row h-100 align-items-center mx-0">
            <div class="w-100">
                <h1 class="text-white">Your Nordic Partner</h1>
                <p class="text-white">built on history, traditions, strong relations and reliability</p>
            </div>
        </div>
    </div>
</div>
